"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchAdapter = void 0;
class FetchResponse {
    constructor(response) {
        this.response = response;
    }
    get status() {
        return this.response.status;
    }
    get headers() {
        const headers = {};
        this.response.headers.forEach((value, key) => {
            headers[key.toLocaleLowerCase()] = value;
        });
        return headers;
    }
    text() {
        return this.response.text();
    }
    json() {
        return this.response.json();
    }
    blob() {
        return this.response.blob();
    }
}
class FetchAdapter {
    request(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers();
            for (let [key, value] of Object.entries(request.headers || {})) {
                headers.set(key, value);
            }
            return fetch(request.url, {
                method: request.method,
                headers,
                body: request.data,
                redirect: 'follow',
            }).then((response) => __awaiter(this, void 0, void 0, function* () { return new FetchResponse(response); }));
        });
    }
}
exports.FetchAdapter = FetchAdapter;
